(function () {
  var dataCache;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stars(rating) {
    var count = Math.max(0, Math.min(5, Number(rating) || 0));
    return '★★★★★'.slice(0, count);
  }

  function cardMarkup(review, fallbackImage, productTitle) {
    var image = (review.images && review.images[0]) || fallbackImage || '';
    var title = review.title ? '<p class="bf-review-proof__title">' + escapeHtml(review.title) + '</p>' : '';
    var body = escapeHtml(review.body || '');
    var authorName = String(review.author || '').trim();
    var author = escapeHtml(/^[A-Z0-9_-]{4,}$/.test(authorName) ? 'Verified buyer' : (authorName || 'Badeloft customer'));
    var product = escapeHtml(productTitle || review.productTitle || '');
    return [
      '<article class="bf-review-proof__card">',
        image ? '<img class="bf-review-proof__image" src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '',
        '<div class="bf-review-proof__shade" aria-hidden="true"></div>',
        '<div class="bf-review-proof__copy">',
          '<div class="bf-review-proof__stars" aria-label="' + escapeHtml(review.rating || 5) + ' out of 5 stars">' + stars(review.rating || 5) + '</div>',
          title,
          '<blockquote class="bf-review-proof__quote">' + body + '</blockquote>',
          '<footer class="bf-review-proof__meta">',
            '<strong>' + author + '</strong>',
            product ? '<span>' + product + '</span>' : '',
          '</footer>',
        '</div>',
      '</article>'
    ].join('');
  }

  function fetchData(url) {
    dataCache = dataCache || fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Review data failed to load');
      return response.json();
    });
    return dataCache;
  }

  function render(root, data) {
    var handle = root.getAttribute('data-product-handle');
    var product = data.products && data.products[handle];
    if (!product || !product.items || !product.items.length) {
      root.hidden = true;
      return;
    }

    var fallbackImage = root.getAttribute('data-fallback-image') || product.productImage || '';
    var productTitle = root.getAttribute('data-product-title') || product.productTitle || '';
    var cards = product.items.slice(0, 6);
    var summary = root.querySelector('[data-bf-review-summary]');
    var track = root.querySelector('[data-bf-review-track]');
    var nav = root.querySelector('[data-bf-review-nav]');

    if (summary) {
      var label = product.count === 1 ? 'review' : 'reviews';
      summary.textContent = product.average.toFixed(1) + '-star average from ' + product.count + ' product-specific ' + label;
    }

    if (track) {
      track.innerHTML = cards.map(function (review) {
        return cardMarkup(review, fallbackImage, productTitle);
      }).join('');
    }

    if (nav) {
      nav.hidden = cards.length <= 3;
    }

    root.hidden = false;
    root.classList.add('bf-review-proof--ready');
    setupReviewJump(root);
  }

  function scrollToReviews(root) {
    var header = document.querySelector('#header-group');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = root.getBoundingClientRect().top + window.pageYOffset - offset - 18;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function setupReviewJump(root) {
    var selectors = [
      'main[data-template*="product"] .jdgm-preview-badge',
      'main[data-template*="product"] .jdgm-prev-badge',
      'main[data-template*="product"] a[href="#judgeme_product_reviews"]',
      'main[data-template*="product"] a[href*="judgeme"]',
      'main[data-template*="product"] .rating-wrapper'
    ];

    function bind() {
      document.querySelectorAll(selectors.join(',')).forEach(function (trigger) {
        if (trigger.dataset.bfReviewJumpBound === 'true') return;
        trigger.dataset.bfReviewJumpBound = 'true';
        trigger.classList.add('bf-review-jump-trigger');

        if (!/^(A|BUTTON)$/i.test(trigger.tagName)) {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('tabindex', '0');
        }

        trigger.setAttribute('aria-label', 'Read product reviews');
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          scrollToReviews(root);
        });
        trigger.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          scrollToReviews(root);
        });
      });
    }

    bind();
    window.setTimeout(bind, 500);
    window.setTimeout(bind, 1500);

    var observer = new MutationObserver(bind);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 6000);
  }

  function init(root) {
    var dataUrl = root.getAttribute('data-review-data-url');
    if (!dataUrl) return;
    fetchData(dataUrl).then(function (data) {
      render(root, data);
    }).catch(function () {
      root.hidden = true;
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bf-review-scroll]');
      if (!button) return;
      var track = root.querySelector('[data-bf-review-track]');
      if (!track) return;
      var direction = button.getAttribute('data-bf-review-scroll') === 'next' ? 1 : -1;
      track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.75), behavior: 'smooth' });
    });
  }

  document.querySelectorAll('[data-bf-review-proof]').forEach(init);
})();
